@if (runData) {
    <div class="row">
        <div class="col-6">
            <div class="d-flex flex-column gap-2">
                <adapt-team-card [team]="runData.team"></adapt-team-card>

                <div class="d-flex flex-column gap-1">
                    <label>{{ teamMembersLabel$ | async }} ({{ runData.createTeamBindingModel.memberPersonIds.length + 1 }})</label>
                    <div class="d-flex flex-column gap-1 ps-1">
                        <div class="team-leader-person-link-container">
                            <adapt-link-person class="team-leader-person-link"
                                               [personId]="runData.createTeamBindingModel.teamLeaderPersonId"
                                               [showImage]="true"
                                               [linkDisabled]="true"
                                               imageSize="sm"
                                               [adaptTooltip]="teamLeaderLabel$ | async"></adapt-link-person>
                        </div>
                        @for (personId of runData.createTeamBindingModel.memberPersonIds; track personId) {
                            <adapt-link-person [personId]="personId"
                                               [showImage]="true"
                                               [linkDisabled]="true"
                                               imageSize="sm"></adapt-link-person>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="col-6">
            <div class="d-flex flex-column gap-2">
                <div class="d-flex flex-column gap-1">
                    <label>Type</label>
                    <adapt-display-team-type [teamTypeConfiguration]="runData.team.teamTypeConfiguration"
                                             [showName]="true"></adapt-display-team-type>
                </div>

                <div class="d-flex flex-column gap-1">
                    <label>Is Private?</label>
                    <div>
                        <adapt-team-private-icon [team]="runData.team"></adapt-team-private-icon>
                        {{ runData.team.isPrivate ? 'Yes' : 'No' }}
                    </div>
                </div>

                <div class="d-flex flex-column gap-1">
                    <label>Features</label>
                    @if (featureConfigItems.length > 0) {
                        <ul class="list-content">
                            @for (featureConfigItem of featureConfigItems; track featureConfigItem.featureName) {
                                <li>{{ featureConfigItem.name }}</li>
                            }
                        </ul>
                    } @else {
                        <div class="text-muted">No features selected.</div>
                    }
                </div>
            </div>
        </div>
    </div>
}
